import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import { ProductContext } from '../context';
import css from './index.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var CareInstructions = function CareInstructions(_ref) {
  var _fabric$careInstructi;

  var title = _ref.title;

  var _useContext = useContext(ProductContext),
      fabric = _useContext.fabric,
      careInstructionOverride = _useContext.careInstructions;

  var careInstructions = careInstructionOverride ? careInstructionOverride === null || careInstructionOverride === void 0 ? void 0 : careInstructionOverride.description : (fabric === null || fabric === void 0 ? void 0 : (_fabric$careInstructi = fabric.careInstructions) === null || _fabric$careInstructi === void 0 ? void 0 : _fabric$careInstructi.description) || '';
  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.panelTitle,
      children: [title, ":"]
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: parseMarkdown(careInstructions)
      }
    }), /*#__PURE__*/_jsxs("a", {
      className: css.careLink,
      href: "/pages/product-care",
      children: ["Read more about how to extend your product\u2019s life", ' ', /*#__PURE__*/_jsx("span", {
        children: "here"
      }), "."]
    })]
  });
};

CareInstructions.propTypes = {
  title: PropTypes.string
};
export default /*#__PURE__*/memo(CareInstructions);